// src/features/selectedDate/selectedDateSlice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import dayjs, { Dayjs } from "dayjs"

interface SelectedDateState {
  selectedDate: string // YYYY-MM-DD 형식으로 저장
}

const initialState: SelectedDateState = {
  selectedDate: dayjs().format("YYYY-MM-DD"), // 오늘 날짜로 초기화
}

const selectedDateSlice = createSlice({
  name: "selectedDate",
  initialState,
  reducers: {
    setSelectedDate: (state, action: PayloadAction<string>) => {
      state.selectedDate = action.payload
    },
    resetToToday: (state) => {
      state.selectedDate = dayjs().format("YYYY-MM-DD")
    },
  },
})

export const { setSelectedDate, resetToToday } = selectedDateSlice.actions
export default selectedDateSlice.reducer
